import { useEffect, useState } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { usd } from "@/components/admin/AdminStats";

const BAR_RADIUS = [6, 6, 0, 0];

const TICK = { fontSize: 11, fill: "var(--mm-text-secondary)" };
const monthLabel = (m) => new Date(`${m}-01T12:00:00`).toLocaleDateString("en-US", { month: "short", year: "2-digit" });

export const GrowthChart = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/growth").then((r) => setRows(r.data)).catch((e) => logError("Growth failed:", e)); }, []);
  if (!rows) return null;
  return (
    <div className="mm-card p-5 mt-4" data-testid="admin-growth-chart">
      <h3 className="font-semibold">Real-member growth · last 6 months</h3>
      <p className="text-xs text-mm-muted mb-3">Test data is always left out.</p>
      <div className="h-60 min-w-0">
        <ResponsiveContainer width="100%" height={240} minWidth={0} initialDimension={{ width: 320, height: 240 }}>
          <ComposedChart data={rows}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--mm-border)" />
            <XAxis dataKey="month" tick={TICK} tickFormatter={monthLabel} />
            <YAxis yAxisId="m" allowDecimals={false} tick={TICK} />
            <YAxis yAxisId="r" orientation="right" tick={TICK} tickFormatter={(v) => `$${v}`} />
            <Tooltip formatter={(v, n) => (n === "Revenue" ? usd(v) : v)} labelFormatter={monthLabel} />
            <Legend />
            <Bar yAxisId="r" dataKey="revenue" name="Revenue" fill="var(--mm-success)" fillOpacity={0.6} radius={BAR_RADIUS} />
            <Bar yAxisId="m" dataKey="new_members" name="New members" fill="var(--mm-primary)" radius={BAR_RADIUS} />
            <Line yAxisId="m" type="monotone" dataKey="total_members" name="Total members" stroke="var(--mm-secondary)" strokeWidth={2.5} dot />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
